import React from 'react';
import 'regenerator-runtime/runtime';
import ChartContext from '../../charts/ChartContext';
import './charts.css';
import SubContext from '../../subs/SubContext';
import { createChart } from '../../chart.utilities';
import PropTypes from 'prop-types';

const DisplayChart = ({
  chartId,
  chartIdYear,
  chartHeight,
  chartWidth,
  subFilterField,
  dateField,
  showAttribution,
  refreshInterval,
}) => {
  const chartCtx = React.useContext(ChartContext);
  const subCtx = React.useContext(SubContext);

  React.useLayoutEffect(() => {
    const chart = createChart(
      chartId,
      chartIdYear,
      chartHeight,
      chartWidth,
      showAttribution,
      refreshInterval,
      subFilterField,
      dateField,
      chartCtx.dateFilter,
      subCtx.selectedSub,
      chartCtx.subFilter,
      chartCtx.subIdFilter
    );

    chart.render(document.getElementById(chartId));
  }, [
    chartId,
    chartCtx.dateFilter,
    chartCtx.subFilter,
    chartHeight,
    chartWidth,
    dateField,
    subCtx.selectedSub,
    chartCtx.subIdFilter,
    chartIdYear,
    subFilterField,
    showAttribution,
    refreshInterval,
  ]);

  return (
    <div className="chartHolder">
      <div className="chart" id={chartId}></div>
    </div>
  );
};

DisplayChart.propTypes = {
  chartId: PropTypes.any,
  chartIdYear: PropTypes.any,
  chartHeight: PropTypes.any,
  chartWidth: PropTypes.any,
  subFilterField: PropTypes.any,
  dateField: PropTypes.any,
  showAttribution: PropTypes.any,
  refreshInterval: PropTypes.any,
};

export default DisplayChart;
